import {
  Default as _, match,
} from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Card, Cash, ComplimentaryTender, GiftCard, MallCertificate, OtherTenderType, PromoVoucher
} from './tender-types';

const OtherTenderTypes = ['StoreCredit', 'Voucher', 'GiftCertificate', 'WireTransfer'];

const matchTenders = (tender, timezone) => match(tender?.Tender?.TenderType || tender?.TenderChange?.TenderType)(
  [() => ['CreditDebit', 'OnlinePayment'].includes(tender?.Tender?.TenderType || tender?.TenderChange?.TenderType), <Card tenderInfo={tender} timezone={timezone} />],
  ['Cash', <Cash tenderInfo={tender} timezone={timezone} />],
  ['GiftCard', <GiftCard tenderInfo={tender} />],
  ['MallCertificate', <MallCertificate tenderInfo={tender} />],
  ['StoreAccount', <ComplimentaryTender tenderInfo={tender} />],
  [() => tender?.Tender?.SubTenderType === 'PromoVoucher', <PromoVoucher tenderInfo={tender} />],
  [() => OtherTenderTypes.includes(tender?.Tender?.TenderType || tender?.TenderChange?.TenderType), <OtherTenderType tenderInfo={tender} timezone={timezone} />],
  [_, ''],
);

const PaymentInformation = ({
  paymentInformation, timezone, storeCreditTenderInfo
}) => (
  <>
    {paymentInformation.map((tender, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <section key={`${tender?.Tender?.TenderType}-${index}`}>
        {matchTenders({ ...tender, ...storeCreditTenderInfo }, timezone)}
      </section>
    ))}
  </>
);

PaymentInformation.defaultProps = {
  paymentInformation: [],
  storeCreditTenderInfo: {},
  timezone: ''
};

PaymentInformation.propTypes = {
  paymentInformation: PropTypes.arrayOf(PropTypes.shape()),
  storeCreditTenderInfo: PropTypes.shape(),
  timezone: PropTypes.string,
};

export default PaymentInformation;
